import React, { Component } from "react"
import Modal from "react-modal"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"
import InterestCollectionModalUI from "./InterestCollectionModalUI"

class InterestCollectionModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      //
      submitted: false,
      //
      collectionDate: '',
      collectionDateError: null,
      //
      collectionAmount: '',
      collectionAmountError: null,
      //
      closeInvoice: ''
    }
  }

  render() {
    return (
      <InterestCollectionModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        //
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        //
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        //
        collectionAmount={this.state.collectionAmount}
        onCollectionAmountChange={(event) => this.setState({ collectionAmount: event.target.value })}
        collectionAmountError={this.state.collectionAmountError}
        setCollectionAmountError={(error) => { this.setState({ collectionAmountError: error }) }}
        //
        collectionDate={this.state.collectionDate}
        onCollectionDateChange={(selectedDateISO) => { this.setState({ collectionDate: selectedDateISO }) }}
        collectionDateError={this.state.collectionDateError}
        setCollectionDateError={(error) => { this.setState({ collectionDateError: error }) }}
        //
        closeInvoice={this.state.closeInvoice}
        onCloseInvoiceChange={() => { this.setState({ closeInvoice: !this.state.closeInvoice }) }}
      />
    )
  }

  onCancelClick = () => {
    this.setState({
      submitted: false,
      errorList: null
    })
    this.props.onCancelClick()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/customers/${this.props.selectedCustomerId}/customerInvoices/${this.props.selectedCustomerInvoiceId}/funds/unutilized/utilize`,
      this.onSubmitCallback, {
      collectionAmount: this.state.collectionAmount,
      collectionDate: this.state.collectionDate,
      closeInvoice: this.state.closeInvoice
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default InterestCollectionModalSF;